import { PRIORITIES } from "../state/state";
import { ChecklistStats, SectionStats } from "../state/stateStats";
import { getPageId, isOverviewPage, ROOT_PAGE_SLUG } from "../utils/utils";

/**
 * Update overview progress bars on the home page
 * @param stats
 * @returns
 */
export function updateOverviewProgress(stats: ChecklistStats): void {
  if (!isOverviewPage()) return;
  for (const [sectionName, sectionStats ] of Object.entries(stats.bySection)) {
    // break out if the section is from home page - no items
    if (sectionName === ROOT_PAGE_SLUG) continue;

    const progressElement = document.querySelector<HTMLProgressElement>(`progress#${sectionName}`);
    // if we don't have a progress bar - break out and warn
    if (!progressElement) {
      console.warn(`Missing <progress> element with id="${sectionName}"`);
      continue;
    }

    progressElement.max = 100;
    progressElement.value = sectionStats.completionPercentage;
    progressElement.setAttribute(
      "aria-label",
      `${sectionName} progress ${sectionStats.completionPercentage}%`
    );

  }

}

/**
 * Update the Progress Bars for each Priority within a Card on the Overview page
 * @param stats ChecklistStats
 * @returns void
 */
export function updateOverviewByPriority(stats: ChecklistStats): void {
  // only run on the overview page
  if (!isOverviewPage()) return;
  for (const prio of PRIORITIES) {
    // If IDs change, we need to update this string
    const id = `overall-${prio}`;
    const el = document.querySelector<HTMLProgressElement>(`progress#${id}`);
    // if the element is not found - break out and warn
    if(!el) {
      console.warn(`Missing <progress> element with id="${id}"`);
      continue;
    }
    // update the progress of the priority level
    el.max = 100;
    // extract priority level from id
    el.value = stats.completionByPriority[prio];
    el.setAttribute(
      "aria-label",
      `${id} progress ${stats.completionByPriority[prio]}`,
    );
  }
}

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function updateSectionProgressByPriority(stats: SectionStats): void {

  const div_progressBarByPriority = document.getElementById("progress-bar-by-priority");

  for(const prio of PRIORITIES) {
    // break out if there are no items
    if (stats.byPriority[prio] == 0) {
      continue
    }
    // check if progress bars exist - remove and recreate
    const existingPriortyBar = document.getElementById(`da-priority-${prio}`);
    if (existingPriortyBar) {
      existingPriortyBar.remove()
    }
    // create the div to show the filled bar
    const div_priorityFill = document.createElement("div");
    div_priorityFill.className = "priority-fill"
    div_priorityFill.id = `priority-fill-${prio}`
    div_priorityFill.setAttribute("style", `width: ${stats.completionByPriority[prio]}%;`);

    // create the priority container and attach the filled bar
    const div_priorityContainer = document.createElement("div");
    div_priorityContainer.className = "priority-container";
    div_priorityContainer.id = `priority-container-${prio}`
    // append the div_priorityFill
    div_priorityContainer.appendChild(div_priorityFill)
    // create the completion text
    const div_priorityBarLabel = document.createElement("div");
    div_priorityBarLabel.className = "priority-bar-label";
    div_priorityBarLabel.id = `priority-bar-label-${prio}`;
    div_priorityBarLabel.textContent = `${capitalize(prio)} (${stats.checkedByPriority[prio]}/${stats.byPriority[prio]})`;
    // create the priority progress bar element
    const div_priorityBar = document.createElement("div");
    div_priorityBar.className = "priority-bar";
    div_priorityBar.id =`da-priority-${prio}`;

    // append the div_priorityBarLabel and the div_priorityContainer
    div_priorityBar.append(
      div_priorityBarLabel,
      div_priorityContainer,
    );

    // append the div_priorityBar to the element div_progressBarByPriority
    div_progressBarByPriority?.appendChild(
      div_priorityBar
    )

  }

}

/**
 * Update progress bars on individual section pages
 * @param stats
 * @returns
 */
export function updateSectionProgress(stats: ChecklistStats): void {
  // Only run on section pages
  if (isOverviewPage()) return
  // update section only if section is in stats
  const slug = getPageId();
  if (
    slug &&
    slug !== undefined &&
    slug in stats.bySection
  ) {
    // get elements to update
    const div_progressBar = document.getElementById("progress-bar-div");
    const span_progressLabel = document.getElementById("progress-label");
    // create attributes and text
        const div_ProgressBar_style = `width: ${stats.bySection[slug].completionPercentage}%;`;
    const span_ProgressLabel_text = `${stats.bySection[slug].completionPercentage}% (${stats.bySection[slug].checked}/${stats.bySection[slug].total})`;
    // update outer elements
    div_progressBar?.setAttribute("style", div_ProgressBar_style);
    if (span_progressLabel) span_progressLabel.textContent = span_ProgressLabel_text;

    // update the progress bars for each priority
    updateSectionProgressByPriority(stats.bySection[slug]);

  }

}
